<template>
  <v-card class="card-box" outlined>
    <router-link
      class="text-link-with-icon"
      :to="{ path: '/newsfeed/view/' + newsFeed._id }"
    >
      <i class="upload-image-box card-outer-box">
        <img
          class="upload-image-box"
          :src="newsfeedImage[0].url"
          v-if="newsfeedImage.length > 0"
        />
        <img
          v-else
          class="upload-image-box"
          src="https://growbiotech-prod.s3.eu-west-2.amazonaws.com/1606300207502.png"
        />
      </i>
      <!-- <v-chip
        color="#FDAF19"
        class="white--text video-chip"
        label
        v-if="newsFeed.videoUrl"
        >VIDEO</v-chip
      > -->
    </router-link>

    <v-card-title>
      <router-link
        class="text-link-with-icon"
        :to="{ path: '/newsfeed/view/' + newsFeed._id }"
      >
        <span class="fixed-title newsfeed-header-title"
          >{{ newsFeed.title }}
        </span>
      </router-link>
    </v-card-title>

    <v-card-text>
      <div class="text-subtitle-1">
        <v-card-text class="summary-section pa-0">
          <p class="fixed-summary mb-0">{{ newsFeed.summary }}</p>
        </v-card-text>
      </div>
    </v-card-text>
    <v-card-title class="dialog-text-sm pt-0">
      {{ publishDate | moment("LL") }}
      <v-spacer></v-spacer>
       <v-icon color="rgb(158, 158, 158)" v-if="newsFeed.videoUrl">
        mdi-youtube
      </v-icon>
      <three-dots :newsFeedData="newsFeed" />
      <!-- <router-link
        class="dialog-title-md"
        :to="{ path: '/newsfeed/view/' + newsFeed._id }"
      >
        READ MORE
        <v-icon color="#344452" size="16">mdi-arrow-right-thick</v-icon>
      </router-link> -->
    </v-card-title>
  </v-card>
</template>

<script>
export default {
  name: "List",
  components: {
    ThreeDots: () => import("./Threedots")
  },
  props: {
    newsFeed: Object
  },
  computed: {
    newsfeedImage() {
      return this.newsFeed.media.filter(
        media => media.mediaType === "image" && media.imageType === "THUMBNAIL"
      );
    },
    publishDate() {
      let date = this.newsFeed.updatedAt;
      if (this.newsFeed.publishedDate != null) {
        date = this.newsFeed.publishedDate;
      }
      return date;
    }
  },
  methods: {
    categoryClick(id) {
      this.$emit("categoryClicked", id);
    }
  }
};
</script>

<style scoped lang="scss">
.card-box {
  box-sizing: border-box;
  height: 375px !important;
  border-radius: 8px;
  border: 1px solid #d6e0ef;
  box-shadow: none !important;
  -webkit-box-shadow: none !important;
}
.card-outer-box{
  border-radius: 8px 8px 0px 0px;
}
.summary-section {
  height: 60px;
}
.fixed-title {
  font-family: "Now Alt";
    font-style: normal;
    font-size: 18px;
    color: #122D4F;
    font-weight: 500;
    text-transform: capitalize;
    word-break: break-word;
    line-height: 28px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  height: 49px;
}
.fixed-summary {
  overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    font-size: 14px;
    line-height: 21px;
    color: #27445B;
}
.v-list-item {
  .list-item {
    cursor: pointer;
  }
}
.infinite-status-prompt {
  display: none !important;
}
.video-chip {
  position: absolute;
  left: 0;
  top: 218px;
  border-radius: 0px !important;
}
.category-cls {
  position: absolute;
  bottom: 15px;
  right: 10px;
  z-index: 2;
  font-family: "Palanquin", sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  letter-spacing: 0.23em;
  text-transform: none;
}
.dots-btn-main {
  position: absolute;
  top: 5px;
  right: 15px;
  z-index: 2;
}
.upload-image-box {
  margin: 0;
  text-align: -webkit-center;
  display: block;
  overflow: hidden;
  background-position: center;
  background-size: contain;
  transition: all 0.4s ease;
  object-position: center;
  object-fit: fill;
  height: 168px;
  background-color: #F6FAFE
}
.upload-image-box:hover {
  overflow: hidden;
  img {
    transform: scale(1.1);
    opacity: 0.9;
  }
}
.youtube {
  position: absolute;
  right: 5px;
}
.dialog-text-sm{
    font-family:'Now Alt';
    font-style: normal;
    font-size: 14px;
    line-height:15px;
    color:gray;
    font-weight: 400;
  }
</style>
